import React from 'react';
import { Box, CheckboxField } from 'bumbag';
import { Field } from 'formik';

import validate from '@medipass/utils/validate-form';

// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
const hasApprovedElectronicLodgement = value => {
  return value !== true ? 'Authorisation for electronic lodgement of claim is required.' : undefined;
};

type Props = {
  className?: string | null | undefined;
};

const ApproveElectronicClaimsLodgement = ({ className }: Props) => {
  return (
    // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
    <Box className={className}>
      <Field
        name="electronicClaimLodgement"
        type="checkbox"
        component={CheckboxField.Formik}
        validate={validate(hasApprovedElectronicLodgement)}
        checkboxLabel="By clicking approve, I authorise electronic lodgement of the claim"
      />
    </Box>
  );
};

ApproveElectronicClaimsLodgement.defaultProps = {
  className: null,
};
export default ApproveElectronicClaimsLodgement;
